import DashboardLayout from "@/pages/layouts/DashboardLayout";

let mediaInfoRoutes = {
    path: '/mediaInfo',
    component: DashboardLayout,
    redirect: '/mediaInfo/list',
    children: [
      {
        path: 'list',
        name: 'Media Info List',
        component: () => import(/* webpackChunkName: "mediaInfo" */  '@/pages/general/mediaInfo/MediaInfoList'),
        meta: {
          permissionsCodes: ['ar/mediaInfo/index'],
        }
      },
      {
        path: 'create',
        name: 'Add Media Info Item',
        component: () => import(/* webpackChunkName: "mediaInfo" */  '@/pages/general/mediaInfo/MediaInfoForm'),
        meta: {
          permissionsCodes: ['ar/mediaInfo/create'],
        }
      },
      {
        path: 'edit/:id',
        name: 'Edit Media Info Item',
        component: () => import(/* webpackChunkName: "mediaInfo" */  '@/pages/general/mediaInfo/MediaInfoForm'),
        meta: {
          permissionsCodes: ['ar/mediaInfo/update'],
        }
      }
    ]
  }

  export default mediaInfoRoutes;
